import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import type { ILandlordOnboardInvite } from 'src/api/onboard-api';
import { useNotifications } from 'src/notifications';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { LANDLORD_SELF_INVITE_PATH } from 'src/services/api/onboarding/invites/constants';

type ICreateInvitesResponse = {
    invite_codes: ILandlordOnboardInvite[];
    num_rows_affected: number;
    num_rows_errors: number;
};

export type ICreateInvitesRequest = {
    emails: string[];
    // is_company_admin: boolean;
}

export const useCreateInvites = () => {
    const queryClient = useQueryClient();
    const { addNotification } = useNotifications();

    return useMutation<
        ICreateInvitesResponse,
        IStandardErrorResponse,
        ICreateInvitesRequest
    >(
        async (payload) => {
            const res = await apiClient(LANDLORD_SELF_INVITE_PATH, {
                method: 'post',
                json: {
                    ...payload,
                    is_company_admin: false,
                },
            }).json<ICreateInvitesResponse>();

            return res;
        }, {
            onSuccess: (res) => {
                addNotification('Invites sent', 'success');

                queryClient.setQueryData<ILandlordOnboardInvite[]>(
                    queryKeys.onboardingInvites,
                    (oldData) => {
                        if (!oldData) {
                            return res.invite_codes;
                        }

                        return [...oldData, ...res.invite_codes];
                    }
                );
            }
        });
};
